import React, { useEffect, createElement } from 'react';
import { StarryBackground } from './components/StarryBackground';
import { CountdownTimer } from './components/CountdownTimer';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      window.fbq('init', '2439831459813015');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-mystic-bg text-text-primary font-outfit selection:bg-gold-primary/30 selection:text-gold-light" data-id="element-0">
      <StarryBackground data-id="element-1" />
      <CountdownTimer data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <FeaturesSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <SocialProofPopup data-id="element-15" />

      {/* Meta Pixel Noscript */}
      <noscript data-id="element-16">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2439831459813015&ev=PageView&noscript=1" alt="" data-id="element-17" />
      </noscript>
    </div>;
}